import { render, staticRenderFns } from "./ezCmsTraveloka.vue?vue&type=template&id=3aa66fae"
import script from "./ezCmsTraveloka.vue?vue&type=script&lang=js"
export * from "./ezCmsTraveloka.vue?vue&type=script&lang=js"
import style0 from "./ezCmsTraveloka.vue?vue&type=style&index=0&id=3aa66fae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports